import apiClient from "./client";

export const getAdminPageContent = async ({ page, language }) => {
  const response = await apiClient.get("/content/admin", {
    params: { page, language },
  });
  return response.data;
};

export const updateContentValue = async ({ id, value }) => {
  const response = await apiClient.put(`/content/admin/${id}/value`, { value });
  return response.data;
};

export const updateContentOrder = async ({ id, order }) => {
  const response = await apiClient.put(`/content/admin/${id}/order`, { order });
  return response.data;
};

export const updateContentActive = async ({ id, isActive }) => {
  const response = await apiClient.put(`/content/admin/${id}/active`, { isActive });
  return response.data;
};

export const uploadContentMedia = async ({ id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/content/admin/${id}/media`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteContentMedia = async ({ id }) => {
  const response = await apiClient.delete(`/content/admin/${id}/media`);
  return response.data;
};

export const createContentItem = async (payload) => {
  const response = await apiClient.post("/content/admin", payload);
  return response.data;
};

export const deleteContentItem = async ({ id }) => {
  await apiClient.delete(`/content/admin/${id}`);
};
